import moment from 'moment';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getLastRefreshDate } from '../../../../services/cesl-bus/tcuService';
import { getISTDate } from '../../../Shared/common';

const TCUContext = createContext();

export const TCUContextProvider = ({ children }) => {

    const [GlobalFilter, setGlobalFilters] = useState({
        search: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        city: [],
        depot: [],
        contract: []
    });

    useEffect(() => {
        getLastRefreshDate()
            .then(res => {
                let date= moment(res?.lastRefreshDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                setGlobalFilters(prev => ({
                    ...prev,
                      startDate: getISTDate(date), 
                      endDate: getISTDate(date)
                }))

            })
    }, [])

    return (
        <TCUContext.Provider value={{ GlobalFilter, setGlobalFilters }}>
            {children}
        </TCUContext.Provider>
    );
};

export const useTCUContextData = () => useContext(TCUContext); 